// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2ZV-h","card":"Cards_card__e44qY","infected":"Cards_infected__2yIt-","recovered":"Cards_recovered__YDsn-","deaths":"Cards_deaths__4sQCX"};